export default __webpack_public_path__ + "static/media/c.c7f0f83e.svg";